import { contentGerman } from '../translations/content_de';
import { contentEnglish } from '../translations/content_en';
import { contentSpanish } from '../translations/content_es';
import { contentFrench } from '../translations/content_fr';
import { contentItalian } from '../translations/content_it';

export const Texts = {
  lang: {
    english: contentEnglish,
    spanish: contentSpanish,
    french: contentFrench,
    italian: contentItalian,
    german: contentGerman
  },
  default: contentEnglish
}
